import React, { useContext, useEffect, useState } from "react";
import style from "./index.module.scss";
import { Input } from "antd";
import {
    findMoreValue,
    OptionItem,
    TopicsItem
} from "../../../../../../../API/exercise";
import { ExerciseContext } from "../../../../../Store";

interface GapFillingProps {
    index?: number;
    data: TopicsItem;
    moreSave: (questionId: string, value: any) => void;
    moreChange: (questionId: string, value: any) => void;
}

export default function PageGapFilling({
    data,
    moreSave,
    moreChange,
    index
}: GapFillingProps) {
    const [objectValue, setObjectValue] = useState<any>();

    const [list, setList] = useState<TopicsItem>();

    const { exercise } = useContext(ExerciseContext);

    useEffect(() => {
        if (data.id && exercise.length > 0) {
            let val = findMoreValue(data.id, exercise);
            let findValue = val;
            let obj: any = {};

            data.options.map((item: any, index) => {
                if (findValue && findValue[item.id]) {
                    obj[item.id] = findValue[item.id];
                } else {
                    obj[item.id] = "";
                }
            });
            setObjectValue(obj);
            let array: OptionItem[] = [];
            data.options.map(item => {
                array.push({ ...item, value: obj[item.id] });
            });
            setList({ ...data, options: array });
        }
    }, [data, exercise]);

    function onBlur(event: React.ChangeEvent<HTMLInputElement>, id: string) {
        let obj = objectValue;
        obj[id] = event.target.value;
        moreSave(data.id, obj);
    }

    function onChange(event: React.ChangeEvent<HTMLInputElement>, id: string) {
        let obj = objectValue;
        obj[id] = event.target.value;
        moreChange(data.id, obj);
    }

    return (
        <div className={style.root} key={data.id}>
            <div className={style.top}>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（填空题，{data.score}分）</span>
                <div className={style.title}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: data.contentText
                        }}
                    />
                </div>
            </div>

            <div className={style.options}>
                {list &&
                    list.options &&
                    list.options.map((item, index) => {
                        return (
                            <div className={style.optionItem} key={item.id}>
                                <div className={style.resultItem}>
                                    <span>填空 {index + 1}</span>
                                    <span className={style.tip}>
                                        (请在下方作答)
                                    </span>
                                </div>
                                <Input
                                    placeholder="请输入答案"
                                    defaultValue={item.value}
                                    maxLength={5000}
                                    onChange={e => onChange(e, item.id)}
                                    onBlur={e => onBlur(e, item.id)}
                                />
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}
